import { render, staticRenderFns } from "./IncomeStatementPrint.vue?vue&type=template&id=3ff10ebc&"
import script from "./IncomeStatementPrint.vue?vue&type=script&lang=js&"
export * from "./IncomeStatementPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports